import { CUSTOM_FORM_FIELDS } from './snippets';

export const getFormById = `//groq
    *[_type == "customForm" && _id == $id][0]{
      ${CUSTOM_FORM_FIELDS}
    }
`;
